import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cliente-painel',
  templateUrl: './cliente-painel.component.html',
  styleUrls: ['./cliente-painel.component.scss']
})
export class ClientePainelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
